import { render, staticRenderFns } from "./VideoSticky.vue?vue&type=template&id=76c5c10f"
import script from "./VideoSticky.vue?vue&type=script&lang=js"
export * from "./VideoSticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports